import React, { useEffect, useRef, useState } from "react";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  USERCOURSES,
  USERLESSON,
  COURSESDETAIL,
  ACCESS_DENIED,
} from "../../../constant/routeContant";
import UserCoursesList from "../component/userCoursesList/userCoursesList";
import * as lmsAction from "../../../redux/actions/lmsAction";
import * as lmsUserAction from "../../../redux/actions/lmsUserAction";
import { useDispatch, useSelector } from "react-redux";
import {
  ORG_ID,
  USER_ID,
  API_STATUS,
  LOGIN_ORG_ID,
} from "../../../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../utils/rolesHelper";
import Loader from "../../../library/common/Loader";
import { InactiveClient, getUserBaseDivisionInfo } from "../../../utils/helper";
import { toast, ToastContainer } from "react-toastify";

const UserCoursesContainer = () => {
  const dispatch = useDispatch();
  const PAGE_SIZE = 6;
  const coursesUserListData = useSelector((state) => state.getUserCoursesList);
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const categoryListData = useSelector((state) => state.getCategoryList?.data);
  const coursesStartData = useSelector((state) => state.startCourse);
  const [courseid, setcourseid] = useState(null);
  const location = useLocation();
  const iscourseNavigatePage = location?.state?.iscourseNavigatePage;
  const [isstart, setisstart] = useState(false);
  const showStartLoader = useSelector(
    (state) => state.startCourse?.isLoading || state.getCategoryList?.isLoading,
  );
  const isClientSwitch = parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID());

  useEffect(() => {
    if (
      coursesStartData?.status === API_STATUS.SUCCESS &&
      (iscourseNavigatePage || isstart)
    ) {
      navigate(COURSESDETAIL, {
        state: { courseId: courseid, courseDetailBackPath: location?.pathname },
      });
    }
  }, [coursesStartData]);

  const defaultData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    statusId: 2,
    userId: isClientSwitch ? 0 : USER_ID(),
    orgId: ORG_ID(),
    divisionId: 0,
    isSendMail: false,
  };
  let navigate = useNavigate();
  const isLoading = useSelector((state) => state.getUserCoursesList?.isLoading);

  const params = new URLSearchParams(location.search);
  const isScorm = params.get("isscorm")?.toLowerCase() === "false";
  const isNotiication = location?.state?.isNotiication === true;

  const initRef = useRef(
    (() => {
      if (isNotiication || isScorm) return null;
      const shouldPreserve =
        sessionStorage.getItem("lmsCoursesPreserveState") === "true";
      if (!shouldPreserve) return null;
      try {
        return JSON.parse(
          sessionStorage.getItem("lmsCoursesFilterObj") || "null",
        );
      } catch {
        return null;
      }
    })(),
  );
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;

    const isAllowedDash = checkPrivileges([12, 11, 10, 9]);
    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }

    const savedFilter = initRef.current;

    if (!savedFilter) {
      dispatch(lmsUserAction.getUserCoursesListFilterObj(defaultData));
      getCoursesUserListData(defaultData);
    } else {
      const restoreData = {
        ...defaultData,
        pageNumber: savedFilter.page != null ? savedFilter.page + 1 : 1,
        search: savedFilter.search || "",
        catIds: savedFilter.selectedValue || "",
        statusId:
          savedFilter.value === 0
            ? 2
            : savedFilter.value === 2
              ? ""
              : savedFilter.value === 1
                ? 1
                : 2,
      };
      getCoursesUserListData(restoreData);
    }
    dispatch(lmsAction.clearCategoryList());
  }, []);
  const getCoursesUserListData = (data) => {
    const payload = {
      ...data,
      divisionId: data?.divisionId ?? 0,
    };
    dispatch(lmsUserAction.getUserCoursesList(payload));
    dispatch(lmsUserAction.getUserCoursesListFilterObj(payload));
  };
  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };

  const dataHeader = {
    title: "My Training",
    menu: [
      {
        route: USERLESSON,
        text: "Lessons",
      },
      {
        route: USERCOURSES,
        text: "Courses",
      },
    ],
  };
  const postunEnrollCourse = (data) => {
    if (InactiveClient()) return;
    dispatch(lmsAction.unEnrollCourse(data));
  };

  return (
    <>
      {" "}
      {showStartLoader && <Loader />}
      <LmsHeader dataHeader={dataHeader} />
      <ToastContainer />
      <UserCoursesList
        coursesUserListData={coursesUserListData.data}
        getCoursesUserListData={getCoursesUserListData}
        categoryUserListData={categoryListData}
        isLoading={isLoading}
        isShow={true}
        setcourseid={setcourseid}
        courseid={courseid}
        setisstart={setisstart}
        isstart={isstart}
        postunEnrollCourse={postunEnrollCourse}
        showDownloadButton={false}
        isAllTab={true}
        getategoryListData={getategoryListData}
        coursesUserListDatas={coursesUserListData}
        isClientSwitch={isClientSwitch}
      />
    </>
  );
};

export default UserCoursesContainer;
